import { HTTP } from '../../utils'

export const getRelatedCareers = (code) => {
  return HTTP().get('/career/relatedCareers/' + code)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const populateCareer = (code) => {
  return HTTP().get('/career/getByCode/' + code)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const populateCareerByCodeAndSource = (code, source) => {
  return HTTP().get('/career/getByCode/' + code + '?source=' + source)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const populateCareerResult = (careerCode, locationParam) => {
  return HTTP().get('/career/emsi/' + careerCode + '?levelAndGeoIds=' + locationParam)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const getCareers = (page, count, name) => {
  if (!page || page < 0) {
    page = 0
  }
  // TODO change endpoint once created
  let url = '/career/findAll?page=' + page
  if (count >= 0) {
    url = url + '&count=' + count
  }
  if (name) {
    url = url + '&name=' + name
  }
  return HTTP().get(url)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}
export const getCareerForProfile = (page, count, name, type) => {
  if (!page || page < 0) {
    page = 0
  }
  // TODO change endpoint once created
  let url = '/career/profile?page=' + page
  if (count >= 0) {
    url = url + '&count=' + count
  }
  if (name) {
    url = url + '&name=' + name
  }
  if (type) {
    url = url + '&type=' + type
  }
  return HTTP().get(url)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}
export const getCareerByCode = (code) => {
  return HTTP().get('career/findByCode/' + code)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const saveCareer = (careerObj) => {
  return HTTP().put('/career/' + careerObj.uuid, careerObj)
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log('Error:' + e)
    })
}

export const populateGeoIds = () => {
  return HTTP().get('/majorMinor/countyMsaStateList')
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const getInsightJobsPostings = (payload) => {
  let config = {
    headers: {
      'Content-Type': 'application/json'
    }
  }
  return HTTP().put('/career/insight/jobs/postings', JSON.stringify(payload), config)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const getInsightJobPosting = (jobId) => {
  return HTTP().get('/career/insight/jobs/postings/' + jobId)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const getLearnerExploreCareers = () => {
  return HTTP().get('/career/learnerExploreCareers')
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}



// WEBPACK FOOTER //
// ./src/app/career/api.js